import React, { useEffect } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import HistoricalReturnsFull from './historical-returns-full';

export const HistoricalReturnsFullWidget = (props) => {
  const queryClient = new QueryClient();
  useEffect(() => {
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'auto';
    body.style.overscrollBehaviorY = 'auto';

    const style = document.createElement('style');
    style.innerHTML = `
      body::-webkit-scrollbar {
        background-color: transparent;
      }
    `;
    document.head.appendChild(style);
  }, []);
  return (
    <QueryClientProvider client={queryClient}>
      <HistoricalReturnsFull {...props} />
    </QueryClientProvider>
  );
};
